import React from 'react';
import styled from 'styled-components';
import { BodyText, FlexColumn } from '@make-software/cspr-design';
import { InfoSection } from 'app/components/management/common/info-section/info-section';

export interface RawDetailsProps {
  url: string;
}

const StyledWrapper = styled.div`
  font-family: Arial, sans-serif;
`;

const SupportInfo = styled.div<{ marginTop?: string }>(({ theme, marginTop }) =>
  theme.withMedia({
    width: ['50%', '65%', '100%'],
    marginTop: marginTop ? marginTop : '20px',
    fontSize: '0.9em'
  })
);

const ApiSnippet = styled.pre`
  font-family: monospace;
  white-space: pre-wrap;
  word-break: break-word; // break long words if needed
  overflow-wrap: anywhere; // modern way to ensure wrapping
`;

export const IntegrationInstructions = ({ url }: RawDetailsProps) => {
  // Request body corresponds to ExtendedTaskItem + user context
  const bodyFormatCode = `{
  "requestID": "<Unique Request ID>",
  "timestamp": "<int64 UTC time>",
  "userID": "<User ID>",
  "targetAppID": "<Target App ID>",
  "targetTaskID": "<Target Task ID>",
  "metadata": "<JSON object with task metadata>",
}`;

  return (
    <StyledWrapper>
      <SupportInfo>
        <InfoSection
          title={'Backend API integration'}
          content={
            <>
              <FlexColumn>
                <BodyText size={1}>Verification request will be sent to:</BodyText>
                <ApiSnippet>POST {url}</ApiSnippet>
              </FlexColumn>
              <FlexColumn>
                <BodyText size={1}>Request body format:</BodyText>
                <ApiSnippet>{bodyFormatCode}</ApiSnippet>
              </FlexColumn>
              <FlexColumn>
                <BodyText size={2}>
                  As a response, your server should return HTTP status code 200 for successful
                  verification or 409 for failed verification.
                </BodyText>
              </FlexColumn>
            </>
          }
        />
      </SupportInfo>
    </StyledWrapper>
  );
};
